import http from '../utils/http';

const defaultState = {
    entityName: 'serviceAccount',
    baseUrl: 'api/grid/',
    profileOptions: ['XRE:X2', 'xtv:x2:android', 'xtv:x2:ios', 'xtv:x2:web']
};

export const actions = {
    fetchGrid({ state }, { serviceAccountId, clientProfile, startDate }) {
        console.log('calling fetchGrid');
        return http.get(
            `${state.baseUrl}?accountId=${serviceAccountId}&clientProfile=${clientProfile}&startDate=${startDate}`,
            {
                notifyRequestPending: true
            }
        );
    }
};

export default {
    namespaced: true,
    state: defaultState,
    actions
};
